import React from "react";
import "./Import.css";

// Generic confirm dialog for destructive actions (Execute, Revert, Overwrite).
export default function ConfirmModal({
	open,
	title,
	children,
	confirmLabel = "Confirm",
	confirmStyle = "danger", // "danger" | "primary"
	busy = false,
	onConfirm,
	onCancel,
}) {
	if (!open) return null;

	return (
		<div className="importModalOverlay" onClick={busy ? undefined : onCancel}>
			<div className="importModal" onClick={(e) => e.stopPropagation()}>
				<h3>{title}</h3>
				<div className="importModalBody">{children}</div>
				<div className="importModalActions">
					<button
						type="button"
						className="importBtn secondary"
						onClick={onCancel}
						disabled={busy}>
						Cancel
					</button>
					<button
						type="button"
						className={`importBtn ${
							confirmStyle === "primary" ? "" : "danger"
						}`}
						onClick={onConfirm}
						disabled={busy}>
						{busy ? "Working…" : confirmLabel}
					</button>
				</div>
			</div>
		</div>
	);
}
